import { Component, ErrorInfo, ReactNode } from 'react';

export interface ErrorBoundaryInnerProps {
  children: ReactNode;
  fallback?: ReactNode | ((error: Error) => ReactNode);
  onError?: (error: Error, errorInfo: ErrorInfo) => void;
}

interface State {
  hasError: boolean;
  error?: Error;
}

export class ErrorBoundaryInner extends Component<ErrorBoundaryInnerProps, State> {
  state: State = { hasError: false };

  static getDerivedStateFromError(error: Error): State {
    return { hasError: true, error };
  }

  componentDidCatch(error: Error, errorInfo: ErrorInfo) {
    this.props.onError?.(error, errorInfo);
  }

  render() {
    if (this.state.hasError && this.state.error) {
      const fallback = this.props.fallback;
      if (typeof fallback === 'function') return fallback(this.state.error);
      if (fallback) return fallback;
      return null;
    }
    return this.props.children;
  }
}
